<!-- <ng-container *ngIf="isLoading$ | async">
</ng-container> -->
<div class="page-title-area page-title-four">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2>{{'MENU.SPECIALTIES' | translate}}</h2>
                <ul>
                    <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>{{'MENU.SPECIALTIES' | translate}}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<ng-container *ngIf="isLoading$ | async">
    <div class="progress progress-modal">
      <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
        style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </ng-container>
  <div class="doctor-search-area" >
    <div class="container">
        <form>
            <div class="row doctor-search-wrap">
                <div class="col-sm-3 col-lg-3"></div>
                <div class="col-sm-6 col-lg-6">
                    <div class="doctor-search-item">
                        <div class="form-group">
                            <i class="icofont-navigation-menu"></i>
                            <label style="font-weight: bold;">{{'APPOINTMENTS.ADD.SPECIALTY' | translate}}</label>
                            <ng-select (change)="OnChangeSpecialty($event)" (search)="OnSearchSpecialty($event)" 
                            [notFoundText]="language == 'en'? 'No results': 'لا توجد نتائج'">
                              <ng-option *ngFor="let Specialty of HospitalSpecialties$" [value]="Specialty.departmentId">
                                {{ language == 'en'?Specialty.departmentName: Specialty.departmentNameArabic }}</ng-option>
                           </ng-select>

                            <!-- <ng-select formControlName="CompanyId" class="ng-select" [items]="HospitalSpecialties$" bindLabel="departmentNameArabic"
                              bindValue="id" notFoundText="لا توجد نتائج للبحث" (search)="OnSearchSpecialty($event)" >
                            </ng-select> -->

                            <!-- <select class="form-control" (change)="OnChangeSpecialty($event)"
                                *ngIf="HospitalSpecialties$ | async as HospitalSpecialties ;else EmptyHospitalSpecialties">
                                <option value=0>{{'COMMON.SELECT' | translate}}</option>
                                <option value={{Specialty.departmentId}}
                                    *ngFor="let Specialty of HospitalSpecialties">{{ language == 'en'?
                                    Specialty.departmentName: Specialty.departmentNameArabic }}</option>
                            </select>
                            <ng-template #EmptyHospitalSpecialties>
                                <select class="form-control">
                                    <option value=0>{{'COMMON.SELECT' | translate}}</option>
                                </select>
                            </ng-template> -->
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div> 
<section class="departments-area" style="padding-top: 30px !important;">
    <div class="container">
        <div class="row">
            <div *ngFor="let Doctor of SpecialtyDoctors;let i = index"
            class="col-lg-4 col-md-12  wow animate__animated animate__fadeInUp" data-wow-delay=".3s" >
                <div class="doctor-item row" style="padding: 30px;margin: 0px 1px 20px 1px;height: 300px;">
                    <div class="col-lg-3 docimg" style="margin-bottom: 15px;">
                        <img *ngIf="Doctor.picPath != null;else NoDocPic" [src]="Doctor.picPath | SafeUrlPipe" alt="Doctor">
                        <ng-template #NoDocPic><img src="assets/img/doctor/Avatar.png" alt="Doctor"></ng-template>
                    </div>
                    
                    <div class="col-lg-2 flagimg" >
                        <img *ngIf="Doctor.apiNationality?.flagPath != null;" [title]="language == 'en'? Doctor.apiNationality?.countryNameEn : Doctor.apiNationality?.countryNameAr"
                            [src]="Doctor.apiNationality?.flagPath | SafeUrlPipe" [alt]="language == 'en' ? Doctor.apiNationality?.countryNameEn : Doctor.apiNationality?.countryNameAr">
                       <!-- <img src="assets/img/home-one/1.png" alt="Doctor" [title]="language == 'en'? Doctor.apiNationality?.countryNameEn : Doctor.apiNationality?.countryNameAr"> -->
                    </div>
                    <div class="col-lg-12 docinfo" style="height: 135px;">
                        <h5 >
                            {{ language == 'en'? 'Dr. '+ Doctor.employee?.firstName +' '+ Doctor.employee?.newLastname
                            : 'د. ' + Doctor.employee?.rFirstName+' '+ Doctor.employee?.rLastName }}</h5>
                        <!-- <h5 >
                            {{ language == 'en'? 'Dr. '+ Doctor.employee?.firstName +' ' + Doctor.employee?.middleName +' '+ Doctor.employee?.newLastname
                            : 'د. ' + Doctor.employee?.rFirstName+' '+ Doctor.employee?.rMiddleName+' '+ Doctor.employee?.rLastName }}</h5> -->
                            <label>{{ language == 'en' ? Doctor.titleEn : Doctor.titleAr }}</label><br>
                            <label>{{ language == 'en'? Doctor.employee?.department?.departmentName : Doctor.employee?.department?.departmentNameArabic }}</label>
                    </div>
                    <div class="col-lg-12" style="height: 50px;">
                        <a routerLink="/login" class="btn btn-primary" (click)="GetAppointment(Doctor.employee?.departmentId,Doctor.employee?.empId)">{{ language == 'en'? 'Get Appointment': 'احجز موعدك' }}</a> 
                    </div>
                </div>
                
            </div>
            <!-- <div *ngFor="let Doctor of SpecialtyDoctors;let i = index"
            class="col-sm-6 col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                <div class="doctor-item" (mouseenter)="OnMouseEnter(i)" (mouseleave)="OnMouseLeave(i)">
                    <div class="doctor-top" *ngIf="DoctorImg[i]" >
                        <img *ngIf="Doctor.picPath != null;else NoDocPic" [src]="Doctor.picPath | SafeUrlPipe" alt="Doctor">
                        <ng-template #NoDocPic><img src="assets/img/doctor/Avatar.png" alt="Doctor"></ng-template>
                        <a routerLink="/login" (click)="GetAppointment(Doctor.employee?.departmentId,Doctor.employee?.empId)">{{ language == 'en'? 'Get Appointment': 'احجز موعدك' }}</a> 
                    </div>
                    <div class="doctor-top" *ngIf="DoctorAbout[i]" >
                        <textarea style="border: none;height: 410px;display: flex;justify-content: center;align-items: center;" readonly class="form-control"  [value]=" language == 'en'?  Doctor.aboutEn : Doctor.aboutAr"></textarea>
                        <a routerLink="/login" (click)="GetAppointment(Doctor.employee?.departmentId,Doctor.employee?.empId)">{{ language == 'en'? 'Get Appointment': 'احجز موعدك' }}</a> 

                    </div>
                    <div class="doctor-bottom">
                        <h3 style="cursor:pointer;"><a (click)="GetAppointment(Doctor.employee?.departmentId,Doctor.employee?.empId)">
                            {{ language == 'en'? 'Dr. '+ Doctor.employee?.firstName +' ' + Doctor.employee?.middleName +' '+ Doctor.employee?.lastName
                            : 'د. ' + Doctor.employee?.rFirstName+' '+ Doctor.employee?.rMiddleName+' '+ Doctor.employee?.rLastName }}</a></h3>
                    </div>
                </div>
            </div> -->
            <!-- <div *ngFor="let Specialty of HospitalSpecialties" 
            class="col-sm-6 col-lg-4" [routerLink]="'/doctor/' + Specialty.departmentId" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" style="cursor:pointer;">
                <div class="department-item wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                    <h3> {{ language == 'en'? Specialty.departmentName: Specialty.departmentNameArabic }}</h3>
                    <hr>            
                    <a *ngIf="Specialty.imagePath != null;else SpecialtyImagePath"><img [src]="Specialty.imagePath | SafeUrlPipe" alt="Specialty" height="200px" width="200px"></a>
                    <ng-template #SpecialtyImagePath><a><img style="transition :0.5s all ease !important" src="assets/img/DefaultImage.png" alt="Specialty" height="250px" width="350px"></a></ng-template>
                </div>
                
            </div> -->
            <!-- <div class="col-sm-6 col-lg-4" routerLink="/doctor"  routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" style="cursor:pointer;">
                <div class="department-item">
                    <i class="icofont-baby"></i>
                    <h3>{{ language == 'en'? 'Baby  Care':'العناية بالطفل' }}</h3>
                    <p>{{ language == 'en'? 'The Department of Pediatrics and Neonatology at the hospital provides advanced and high-quality medical care for children from birth to 14 years of age.':
                        'يقدم قسم طب الأطفال وحديثي الولادة  في المستشفى رعاية طبية متطورة  وعالية الجودة  للأطفال منذ الولادة  وحتى عمر ال 14 سنة.' }}</p>
                </div>
            </div>
            <div class="col-sm-6 col-lg-4" routerLink="/doctor"  routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" style="cursor:pointer;">
                <div class="department-item">
                    <i class="icofont-laboratory"></i>
                    <h3>{{ language == 'en'? 'Laboratories':'المختبرات' }}</h3>
                    <p>{{ language == 'en'? 'The Family Care Hospital Laboratories Division is a regionally recognized laboratory with accreditation from national and international regulatory bodies to contribute to facilitating high quality laboratory testing to assist patients.':
                        'يعنبر قسم مختبرات مستشفى عناية العائله من المختبرات المعترف بها إقليميا مع اعتماد من الهيئات التنظيمية الوطنية والدولية. للمساهمة في تسهيل الاختبارات المختبرية عالية الجودة لمساعدة المرضى.' }}</p>
                </div>
            </div>
            <div class="col-sm-6 col-lg-4" routerLink="/doctor"  routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" style="cursor:pointer;">
                <div class="department-item">
                    <i class="icofont-icu"></i>
                    <h3>{{ language == 'en'? 'ICU':'وحدة العناية المركزة' }}</h3>
                    <p>{{ language == 'en'? 'The intensive care departments contain the best equipment from Electric General, which is distinguished in providing diagnostic and therapeutic devices such as vital signs monitors and ventilators, as well as cardiac resuscitation devices.':
                        'تحتوي أقسام العناية المركزة على أفضل الأجهزة من شركة  Electric General المتميزة في تقديم الأجهزة التشخيصية والعلاجية مثل اجهزة رصد العلامات الحيوية وأجهزة التنفس الصناعي كما تحتوي على أجهزة للإنعاش القلبي.' }}</p>
                </div>
            </div>

            <div class="col-sm-6 col-lg-4" routerLink="/doctor"  routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" style="cursor:pointer;">
                <div class="department-item">
                    <i class="icofont-dna-alt-2"></i>
                    <h3>{{ language == 'en'? 'Radiology and Medical Imaging':' الأشعة والتصوير الطبي' }}</h3>
                    <p>{{ language == 'en'? 'The Medical Imaging Department is one of the most important departments in all hospitals in the world. It is responsible for diagnosing diseases with high accuracy through measurements, physiological imaging and electronic planning.':
                        'عتبر قسم التصوير الطبي من أهم الأقسام في جميع مستشفيات العالم، فهو المسؤول عن تشخيص الأمراض بدقة عالية من خلال عمليات القياس والتصوير الفيسيولوجي والتخطيط الالكتروني' }}</p>
                </div>
            </div>

            <div class="col-sm-6 col-lg-4" routerLink="/doctor"  routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" style="cursor:pointer;">
                <div class="department-item">
                    <i class="icofont-surgeon"></i>
                    <h3>{{ language == 'en'? 'General Surgery and laparoscopic ':'الجراحة العامة والمناظير' }}</h3>
                    <p>{{ language == 'en'? 'At Family Care Hospital, you can count on a skilled team of surgeons who can help you make the right decision regarding the surgical option that is best for you.':
                        'في مستشفى  عناية العائلة  يمكنك الاعتماد على فريق ماهر من الجراحين الذين يمكنهم مساعدتك على اتخاذ القرار الملائم بالنسبة للخيار الجراحي الأفضل لك.' }}</p>
                </div>
            </div> -->

            <!-- <div class="col-sm-6 col-lg-4">
                <div class="department-item">
                    <i class="icofont-xray"></i>
                    <h3>X-ray</h3>
                    <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Praesentium eaque omnis corporis, animi
                        aspernatur tempora.</p>
                </div>
            </div> -->

            <!-- <div class="col-sm-6 col-lg-4">
                <div class="department-item">
                    <i class="icofont-blood-test"></i>
                    <h3>Blood Test</h3>
                    <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Praesentium eaque omnis corporis, animi
                        aspernatur tempora.</p>
                </div>
            </div> -->

            <!-- <div class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4">
                <div class="department-item">
                    <i class="icofont-ambulance-crescent"></i>
                    <h3>Ambulance Service</h3>
                    <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Praesentium eaque omnis corporis, animi
                        aspernatur tempora.</p>
                </div>
            </div> -->
        </div>
    </div>
</section>